{
  "ATTRIBUTES_MGMT": {
    "HEADER": "Egyedi atribútumok",
    "HEADER_BTN_TXT": "Adj meg egyedi tulajdonságot",
    "LOADING": "Vonzó egyedi tulajdonság",
    "DESCRIPTION": "Az egyéni tulajdonság további adatokat tárol a kontaktokról vagy a beszélgetésekről, például az előfizetési csomagot vagy az első vásárlás dátumát. Különböző típusú egyéni tulajdonságokat adhat hozzá, például szöveget, listát vagy számot, hogy rögzítse a szükséges információkat.",
    "LEARN_MORE": "Tudjon meg többet az egyéni tulajdonságokról",
    "ATTRIBUTE_TYPES": {
      "TEXT": "Szöveg",
      "NUMBER": "Szám",
      "LINK": "Hivatkozás",
      "DATE": "Dátum",
      "LIST": "Lista",
      "CHECKBOX": "Jelölőnégyzet",
      "TEXT_AREA": "Szövegterület"
    },
    "ADD": {
      "TITLE": "Adj meg egyedi tulajdonságot",
      "SUBMIT": "Létrehozás",
      "CANCEL_BUTTON_TEXT": "Mégse",
      "FORM": {
        "NAME": {
          "LABEL": "Rövidnév",
          "PLACEHOLDER": "Add meg az egyéni tulajdonság rövidnevét",
          "ERROR": "Név kötelező"
        },
        "DESC": {
          "LABEL": "Leírás",
          "PLACEHOLDER": "Add meg az egyéni tulajdonság leírását",
          "ERROR": "Leírás megadása kötelező"
        },
        "MODEL": {
          "LABEL": "Vonatkozik",
          "PLACEHOLDER": "Kérlek, válassz egyet",
          "ERROR": "Modell megadása kötelező"
        },
        "TYPE": {
          "LABEL": "Típus",
          "PLACEHOLDER": "Kérlek, válaszd ki a típust",
          "ERROR": "Típus megadása kötelező",
          "LIST": {
            "LABEL": "Lista értékek",
            "PLACEHOLDER": "Kérlek add meg az értéket és lépj be a kulccsal",
            "ERROR": "Legalább egy érték megadása kötelező"
          }
        },
        "KEY": {
          "LABEL": "Kulcs",
          "PLACEHOLDER": "Add meg az egyéni tulajdonság kulcsát",
          "ERROR": "Kulcs megadása kötelező",
          "IN_VALID": "Érvénytelen kulcs"
        },
        "REGEX_PATTERN": {
          "LABEL": "Regex minta",
          "PLACEHOLDER": "Adja meg az egyéni tulajdonság regex mintáját. (Opcionális)"
        },
        "REGEX_CUE": {
          "LABEL": "Regex tipp",
          "PLACEHOLDER": "Adjon meg egy tippet a regex mintához. (Opcionális)"
        },
        "ENABLE_REGEX": {
          "LABEL": "Regex ellenőrzés engedélyezése"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Sikeresen hozzáadtad ezt az egyedi tulajdonságot!",
        "ERROR_MESSAGE": "Nem tudsz létrehozni Egyéni Tulajdonságot. Kérlek, próbáld újra később."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Törlés",
      "API": {
        "SUCCESS_MESSAGE": "Egyéni Tulajdonság sikeresen törölve.",
        "ERROR_MESSAGE": "Egyéni Tulajdonság törlése sikertelen. Próbáld újra."
      },
      "CONFIRM": {
        "TITLE": "Biztosan törölni akarod: {attributeName}",
        "PLACE_HOLDER": "Kérlek gépeld a megerősítéshez",
        "MESSAGE": "A törlés eltávolítja az egyéni tulajdonságot",
        "YES": "Törlés ",
        "NO": "Mégse"
      }
    },
    "EDIT": {
      "TITLE": "Egyéni tulajdonság szerkesztése",
      "UPDATE_BUTTON_TEXT": "Frissítés",
      "TYPE": {
        "LIST": {
          "LABEL": "Lista értékek",
          "PLACEHOLDER": "Kérlek add meg az értéket és lépj be a kulccsal"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Egyéni Tulajdonság sikeresen frissítve",
        "ERROR_MESSAGE": "Hiba történt az egyéni tulajdonság frissítésekor. Kérjük próbáld később"
      }
    },
    "TABS": {
      "HEADER": "Egyedi atribútumok",
      "CONVERSATION": "Beszélgetés",
      "CONTACT": "Kontakt"
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Név",
        "DESCRIPTION": "Leírás",
        "TYPE": "Típus",
        "KEY": "Kulcs"
      },
      "BUTTONS": {
        "EDIT": "Szerkesztés",
        "DELETE": "Törlés"
      },
      "EMPTY_RESULT": {
        "404": "Nincsennek létrehozva egyéni tulajdonságok",
        "NOT_FOUND": "Nincsennek beállítva egyéni tulajdonságok"
      },
      "REGEX_PATTERN": {
        "LABEL": "Regex minta",
        "PLACEHOLDER": "Adja meg az egyéni tulajdonság regex mintáját. (Opcionális)"
      },
      "REGEX_CUE": {
        "LABEL": "Regex tipp",
        "PLACEHOLDER": "Adjon meg egy tippet a regex mintához. (Opcionális)"
      },
      "ENABLE_REGEX": {
        "LABEL": "Regex ellenőrzés engedélyezése"
      }
    }
  }
}
